import { lazy } from 'react';
import reducer from './state/reducers';
import { getStore } from '@AppRedux/store';
import checkAuth from '@Utils/checkAuth';

const store = getStore();

const OnboardingTrainingTrackerList = lazy(() =>
    import('./OnboardingTrainingTrackerList').then(async module => {
        await checkAuth();
        const auth = getStore().getState().auth;
        if(auth.isAuthenticated) {
            store.injectReducer('onboardingTrainingTrackerList', reducer.listReducer);
            return module;
        }
    })
);

const OnboardingTrainingTrackerDetail = lazy(() =>
    import('./OnboardingTrainingTrackerDetail').then(async module => {
        await checkAuth();
        const auth = getStore().getState().auth;
        if(auth.isAuthenticated) {
            store.injectReducer('onboardingTrainingTrackerDetail', reducer.detailReducer);
            return module;
        }
    })
);

const OnboardingTrainingTrackerRoutes = [
    {
        label: 'Onboarding Training Tracker',
        path: '/HRAutomation/OnboardingTrainingTracker',
        menuName: 'hrAutomation',
        component: OnboardingTrainingTrackerList,
        icon: 'fa-user',
        exact: true,
        showNav: true, 
        public: true, 
    },
    {
        label: 'Onboarding Training Tracker',
        path: '/HRAutomation/OnboardingTrainingTracker/:mode/:id',
        component: OnboardingTrainingTrackerDetail,
        exact: true,
        showNav: false, 
        public: true,
    },
]

export default OnboardingTrainingTrackerRoutes;